<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="2">
                <b-form-group label="Nama">
                    <b-form-input v-model="kondisi.name" name="kondisiName" placeholder="Nama" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group v-if="!isKendaraan" label="Packing">
                    <b-form-select v-model="kondisi.dus" name="kondisiPacking" :options="kondisiOption" value-field="id" text-field="name" required>
                    </b-form-select>
                </b-form-group>
                <b-form-group v-else label="BPKB">
                    <b-form-select v-model="kondisi.namaSendiri" name="kondisiKendaraan" :options="kondisiKendaraan" value-field="id" text-field="name" required>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Harga Maksimal">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="kondisi.hargaMaksimal" name="kondisiHargaMaksimal" :id="`hargaMaksimalDesc-${kondisi.index}`" required></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-popover :target="`hargaMaksimalDesc-${kondisi.index}`" title="Catatan" triggers="focus">
                    Tulis 0 apabila tidak ada harga maksimal
                </b-popover>
            </b-col>
            <b-col md="2">
                <b-form-group>
                    <label class="radio-label">
                        <b-form-radio v-model="kondisi.detailInfo" value="persen">Persen</b-form-radio>
                    </label>
                    <b-input-group append="%">
                        <b-form-input v-model="kondisi.nominalPersen" :id="`persenKondisiDesc-${kondisi.index}`" name="kondisiNominalPersen" step="0.01" type="number" @blur="roundPersen" :disabled="kondisi.detailInfo == 'nominal'" required></b-form-input>
                        <b-popover :target="`persenKondisiDesc-${kondisi.index}`" title="Catatan" triggers="focus">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                                </li>
                                <li class="mb-0">
                                    <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                                </li>
                            </ul>
                        </b-popover>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group>
                    <label class="radio-label">
                        <b-form-radio v-model="kondisi.detailInfo" value="nominal">Nominal</b-form-radio>
                    </label>
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="kondisi.nominalAngka" name="kondisiNominalAngka" :disabled="kondisi.detailInfo == 'persen'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="form-dynamic-deleteWrapper">
            <b-button class="btn-dynamicActiveBtn" name="aktifKondisi" @click="$emit('aktif', kondisi.index)"><i class="fa fa-plus"></i></b-button>
            <!-- <b-button variant="dynamicDeleteBtn" name="deleteKondisi" @click="$emit('remove', kondisi.index)" :disabled="length == 1"><i class="fa fa-times"></i></b-button>
            <b-button variant="dynamicDeleteBtn mt-2" name="nonAktifKondisi" :disabled="kondisi.id == 0" @click="$emit('nonAktif', kondisi.index)"><i class="fa fa-minus"></i></b-button> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'kondisi-non-aktif',
    data(){
        return{
            kondisiOption: [
                {id: 0, name: 'Dus'},
                {id: 1, name: 'Non Dus'},
            ],
            kondisiKendaraan: [
                {id: 0, name: 'Nama Sendiri'},
                {id: 1, name: 'Nama Orang Lain'}
            ]
        }
    },
    props: {
        kondisi: { type: Object, required: true },
        length: { type: Number, required: true },
        isKendaraan: { type: Boolean, required: true }
    },
    watch: {
        "kondisi.nominalAngka": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.kondisi.nominalAngka = result);
        },
        "kondisi.hargaMaksimal": function(newValue) {
            if(newValue != ""){
                let cleanValue = this.$helper.changeToValue(newValue);
                const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/^0+/, "");
                this.$nextTick(() => this.kondisi.hargaMaksimal = result);
            }else{
                this.$nextTick(() => this.kondisi.hargaMaksimal = 0);
            }
        },
    },
    methods: {
        roundPersen(){
            var x = Number(this.kondisi.nominalPersen).toFixed(2);
            this.kondisi.nominalPersen = x;
        }
    }
}
</script>
